export default [
    '1',
    '1.5',
    '2',
    '2.5',
    '3',
    '3.5',
    '4',
    'biLevel',
    'triLevel',
];